import managementApi from '@utils/managementApi';

export const startUpload = async (
  file: File,
  organization_id: string,
): Promise<{ uploadUrl: string; id: string }> => {
  try {
    const response = await managementApi.post<{
      uploadUrl: string;
      id: string;
    }>(`/v2/organizations/${organization_id}/uploads`, {
      originalFileName: file.name,
    });
    return response.data;
  } catch (error) {
    console.error('Error starting file upload:', error);
    throw error;
  }
};

export const endUpload = async (
  id: string,
  organization_id: string,
): Promise<{ success: boolean; url: string }> => {
  try {
    const response = await managementApi.post<{ success: boolean }>(
      `/v2/organizations/${organization_id}/uploads/${id}/complete`,
    );
    return response.data;
  } catch (error) {
    console.error('Error completing file upload:', error);
    throw error;
  }
};
export const summarizeFile = async ({
  mentorId,
  uploadId,
  socketId,
}: {
  mentorId: string;
  uploadId: string;
  socketId: string;
}): Promise<{ success: boolean }> => {
  try {
    const response = await managementApi.post<{ success: boolean }>(
      `/v2/mentors/${mentorId}/files/${uploadId}/summarize`,
      {
        socketId,
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error summarizing file:', error);
    throw error;
  }
};

export const removeKnowledgeFile = async ({
  mentorId,
  uploadId,
}: {
  mentorId: string;
  uploadId: string;
}): Promise<{ success: boolean }> => {
  try {
    const response = await managementApi.delete<{ success: boolean }>(
      `/v2/mentors/${mentorId}/knowledge-bases/files/${uploadId}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error removing file:', error);
    throw error;
  }
};

export const removeUploadedFile = async ({
  id,
  organization_id,
}: {
  id: string;
  organization_id: string;
}): Promise<{ success: boolean }> => {
  try {
    const response = await managementApi.delete<{ success: boolean }>(
      `/v2/organizations/${organization_id}/uploads/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error removing file:', error);
    throw error;
  }
};
